import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TypingIndicator.module.css';
import { CHAT_DRAWER_TEST_IDS } from '../testIds';

const TypingIndicator: FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className={styles.typingIndicator}
      role="status"
      aria-label={t('components.aiChatDrawer.typingIndicator.ariaLabel')}
      data-testid={CHAT_DRAWER_TEST_IDS.typingIndicator}
    >
      <span className={styles.dot} />
      <span className={styles.dot} />
      <span className={styles.dot} />
    </div>
  );
};

export default TypingIndicator;
